import {createContext, useContext} from "react";
import {useUser} from "../repos/users";
import {useAuth} from "./Auth";
import useApiFetchV2 from "../hooks/useApiFetchV2";

module Me {

    export interface Role {
        id: number;
        name: string;
    }

    export interface RootObject {
        id: string;
        name?: any;
        vendor_name?: any;
        phone: string;
        email: string;
        address?: any;
        credit: number;
        debit: number;
        is_disabled: boolean;
        created_at: Date;
        updated_at: Date;
        roles: Role[];
    }

}


type Context = {
    role?: string
}

const context = createContext<Context>({})


export const RoleProvider = ({children}: { children: React.ReactNode }) => {

    const {token} = useAuth()

    const user = useApiFetchV2<Me.RootObject>('me', {}, {
        isPaused() {
            return !token
        }
    })
    return <context.Provider value={{
        role: user?.data?.roles?.[0]?.name === 'accountant' ? 'accountant' : 'admin',
    }}>
        {!user.loading || !token ? children : <></>}
    </context.Provider>
}


export const useRole = () => useContext(context)?.role
